<template>
  <div class="candidate-events-grid">
    <grid
      ref="eventsGrid"
      :show-header="true"
      :list-url="listUrl"
      loading-message="Loading events ..."
      :edit-action-as-link="false"
    >
      <template #header>
        Events
      </template>
      <template #action-cell="participant">
        <a
          v-if="participant.item.links.show_participant"
          href="#"
          class="btn btn-sm btn-success"
          @click.prevent="showParticipantDetails(participant.item)"
        >
          Details
        </a>
        <a
          v-if="participant.item.links.show_team"
          :href="participant.item.links.show_team"
          target="_blank"
          class="btn btn-sm btn-success"
        >
          Details
        </a>
      </template>
    </grid>
    <teleport
      to="#vue-portal-target"
      append
    >
      <candidate-modal
        ref="participantModal"
        modal-title="Edit participant"
        @success="participantModalSuccess"
      />
    </teleport>
  </div>
</template>
<script setup lang="ts">
import {useTemplateRef} from 'vue'
import Grid from './grid.vue'
import CandidateModal from './candidate-modal.vue'

defineProps({
  listUrl: {default: undefined, type: String}
})

const eventsGrid = useTemplateRef<InstanceType<typeof Grid>>('eventsGrid')
const participantModal = useTemplateRef<InstanceType<typeof CandidateModal>>('participantModal')

const showParticipantDetails = (participant: any): void => {
  participantModal.value?.showModal(participant.links.show_participant, null)
}

const participantModalSuccess = (): void => {
  participantModal.value?.hideModal()
  eventsGrid.value?.reload()
}
</script>
